<template>
  <div class="page">
    <PageHeader>
      Страница не найдена!
    </PageHeader>
    <div class="content">
      404
    </div>
  </div>
</template>
<script>
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/NotFound/index.vue